import { useTranslation } from "react-i18next";
import ExternalActionBanner from "components/ExternalActionBanner/ExternalActionBanner";
import { DSU_QUESTIONNAIRE_URL } from "config/ExternalLinksConfig";

const SurveyBanner = () => {
  const { t } = useTranslation();
  return (
    <ExternalActionBanner headingId="home-survey-title"
      title={t("view.homePage.survey.title")}
      description={t("view.homePage.survey.description")}
      href={DSU_QUESTIONNAIRE_URL}
      actionText={t("view.homePage.survey.button")}
      linkLabel={t("view.homePage.survey.linkLabel")} />
  );
};

export default SurveyBanner;
